<template>
    <!-- 娱乐休闲  -->
     <main-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg" />
</template>

<script>
import MainPage from '@/views/components/MainPage.vue'
export default {
    name: 'entertainment',
    components: {
        MainPage
    },
    data() {
        return {
            bg: "/img/pay/0--48.png",
        }
    },
    computed: {
        title() {
            return this.$t('entertainment.title');
        },
        subtitle() {
            return this.$t('entertainment.subtitle');
        },
        description() {
            return this.$t('entertainment.description');
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    },
}
</script>